import { ShieldCheck } from 'lucide-react';

/** Lucide icon for USPS-validated address — use with `Button` `iconLeft` or pass to `Icon`. */
export const addressUspsValidatedLucideIcon = ShieldCheck;
